import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { getRetryDelay, shouldRetryRequest } from '@/shared/lib/query/retryConfig';

import { runManagementApi } from '@/entities/run/api/runManagementApi';
import type { GetRunsParams, RunListResponse } from '@/entities/run/domain/runManagementTypes';

export const RUN_MANAGEMENT_QUERY_KEY = 'run-management';

export const useRunManagementList = (params?: GetRunsParams, enabled = true) => {
  return useQuery<RunListResponse>({
    queryKey: [RUN_MANAGEMENT_QUERY_KEY, params],
    queryFn: () => runManagementApi.getList(params),
    enabled,
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    refetchInterval: enabled ? 5000 : false,
    retry: shouldRetryRequest,
    retryDelay: getRetryDelay,
    placeholderData: keepPreviousData,
  });
};
